import { apiSlice } from "../api/apiSlice";

export const membersApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMember: builder.query({
      query: () => ({
        url: "/team",
        method: "GET",
      }),
    }),
  }),
});

export const {useGetMemberQuery} = membersApi;